import {
  FETCH_TRANSACTION_REQUEST,
  FETCH_TRANSACTION_SUCCESS,
  FETCH_TRANSACTION_FAILURE,
} from "./transactionDetailsTypes";
import api from "../../utils/Api";

export const fetchTransactionRequest = () => {
  return {
    type: FETCH_TRANSACTION_REQUEST,
  };
};

export const fetchTransactionSuccess = (transactionDetails) => {
  return {
    type: FETCH_TRANSACTION_SUCCESS,
    payload: transactionDetails,
  };
};

export const fetchTransactionFailure = (error) => {
  return {
    type: FETCH_TRANSACTION_FAILURE,
    payload: error,
  };
};

export const fetchTransaction = (payment_id) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchTransactionRequest());
    try {
      const response = await api.get(
        "payment/detail/fetch?payment_id=" + payment_id,
        {
          headers: headers,
        }
      );
      const transactionDetails = response.data.data;
      dispatch(fetchTransactionSuccess(transactionDetails));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchTransactionFailure(errorMsg));
    }
  };
};
